import React from 'react';
import {
  RewardsAndOffersProvider,
  NationalAccountProvider,
} from '../../../contexts';

interface IPageProvidersProps {
  children: React.ReactNode;
  page?: string;
}

const AllProviders = ({ children }: any) => (
  <RewardsAndOffersProvider>
    <NationalAccountProvider>
      <>{children}</>
    </NationalAccountProvider>
  </RewardsAndOffersProvider>
);

const PricingBenefitsProviders = ({ children }: any) => (
  <RewardsAndOffersProvider>
    <>{children}</>
  </RewardsAndOffersProvider>
);

const PricingBooksProviders = ({ children }: any) => (
  <RewardsAndOffersProvider>
    <>{children}</>
  </RewardsAndOffersProvider>
);

export const PageProviders: React.FC<IPageProvidersProps> = ({
  children,
  page,
}: any) => {
  let ChildProviders: React.ReactNode = <AllProviders>{children}</AllProviders>;
  switch (page) {
    case 'PricingBenefitsPage':
      ChildProviders = (
        <PricingBenefitsProviders>{children}</PricingBenefitsProviders>
      );
      break;
    case 'PricingBooksPage':
      ChildProviders = (
        <PricingBooksProviders>{children}</PricingBooksProviders>
      );
      break;
    default:
      break;
  }
  return <>{ChildProviders}</>;
};
